import NotificationBanner from './NotificationBanner.container'

export default NotificationBanner
